export type {ChatConfig} from './types';
export {setConfig, getConfig, DEFAULT_CONFIG} from './config';
